var $ = require('jquery');

module.exports = (function(){

  $('.js-navbtn').on('click', function() {
    $('.nav-popup').fadeIn(200);
    $('body').css('overflow', 'hidden');
  });

  $('.js-navbtn-close').on('click', function() {
    $('.nav-popup').fadeOut(200);
    $('body').css('overflow', '');
  });

})();



// WEBPACK FOOTER //
// ./components/nav_popup.js